import { Product } from '../types/product'

export const SEARCH_SYNONYMS: Record<string, string[]> = {
  кава: ['coffee', 'kava', 'кава', 'кави', 'кавою'],
  дріп: ['dripi', 'дріп', 'дріпи', 'дрипів', 'дрипами'],
  дріпи: ['dripi', 'дріп', 'дріпи', 'дрипів', 'дрипами'],
  'пачка дрипів': ['dripi', 'дріп', 'дріпи', 'дрипів', 'дрипами', 'пачка'],
  капсула: ['kapsuli', 'капсула', 'капсули', 'капсул', 'капсулами', 'capsule', 'capsules'],
  капсули: ['kapsuli', 'капсула', 'капсули', 'капсул', 'капсулами', 'capsule', 'capsules'],
  capsule: ['kapsuli', 'капсула', 'капсули', 'капсул', 'capsule', 'capsules'],

  колумбія: ['colombia', 'колумбія', 'колумбійська', 'colombian'],
  ефіопія: ['ethiopia', 'ефіопія', 'ефіопська', 'ethiopian'],
  бразилія: ['brazil', 'бразилія', 'бразильська', 'brazilian'],
  гватемала: ['guatemala', 'гватемала', 'гватемальська', 'guatemalan'],
  кенія: ['kenya', 'кенія', 'кенійська', 'kenyan'],
  'коста-рика': ['costa rica', 'коста-рика', 'костариканська', 'costarican'],
  перу: ['peru', 'перу', 'перуанська', 'peruvian'],
  мексика: ['mexico', 'мексика', 'мексиканська', 'mexican'],
  індія: ['india', 'індія', 'індійська', 'indian'],
  індонезія: ['indonesia', 'індонезія', 'індонезійська', 'indonesian'],
  "в'єтнам": ['vietnam', "в'єтнам", "в'єтнамська", 'vietnamese'],
  гаваї: ['hawaii', 'гаваї', 'гавайська', 'hawaiian'],
  ямайка: ['jamaica', 'ямайка', 'ямайська', 'jamaican'],
  'доминіканська республіка': ['dominican republic', 'доминіканська республіка', 'доминіканська'],
  гаїті: ['haiti', 'гаїті', 'гаїтянська', 'haitian'],
  еквадор: ['ecuador', 'еквадор', 'еквадорська', 'ecuadorian'],
  болівія: ['bolivia', 'болівія', 'болівійська', 'bolivian'],
  панама: ['panama', 'панама', 'панамська', 'panamanian'],
  нікарагуа: ['nicaragua', 'нікарагуа', 'нікарагуанська', 'nicaraguan'],
  гондурас: ['honduras', 'гондурас', 'гондураська', 'honduran'],
  сальвадор: ['el salvador', 'сальвадор', 'сальвадорська', 'salvadoran'],

  сидамо: ['sidamo', 'сидамо', 'sidama'],
  йіргачефе: ['yirgacheffe', 'йіргачефе', 'yirgachefe'],
  харрар: ['harar', 'харрар', 'harrar'],
  антіокія: ['antioquia', 'антіокія', 'antioquia'],
  хуїла: ['huila', 'хуїла', 'huila'],
  нариньо: ['nariño', 'нариньо', 'narino'],
  'сан-маркос': ['san marcos', 'сан-маркос', 'sanmarcos'],
  акатенанго: ['acatenango', 'акатенанго', 'acatenango'],
  антігуа: ['antigua', 'антігуа', 'antigua'],
  атітлан: ['atitlan', 'атітлан', 'atitlan'],
  кобан: ['coban', 'кобан', 'coban'],
  фрайлес: ['frailes', 'фрайлес', 'frailes'],
  ніяранга: ['nyaranga', 'ніяранга', 'nyaranga'],
  кіріньяга: ['kirinyaga', 'кіріньяга', 'kirinyaga'],
  ньєрі: ['nyeri', 'ньєрі', 'nyeri'],
  ембу: ['embu', 'ембу', 'embu'],
  меру: ['меру', 'меру', 'meru'],
  мачакос: ['machakos', 'мачакос', 'machakos'],
  тіка: ['tika', 'тіка', 'tika'],
  джимма: ['jimma', 'джимма', 'jimma'],
  ліму: ['lima', 'ліму', 'lima'],
  чачапояс: ['chachapoyas', 'чачапояс', 'chachapoyas'],
  куско: ['cuzco', 'куско', 'cuzco'],
  'сан-мартін': ['san martin', 'сан-мартін', 'sanmartin'],
  піура: ['piura', 'піура', 'piura'],
  аякучо: ['ayacucho', 'аякучо', 'ayacucho'],
  хуануко: ['huanuco', 'хуануко', 'huanuco'],
  амазонас: ['amazonas', 'амазонас', 'amazonas'],
  'ла-лібертад': ['la libertad', 'ла-лібертад', 'lalibertad'],
  кахамарка: ['cajamarca', 'кажамарка', 'cajamarca'],
  анкаш: ['ancash', 'анкаш', 'ancash'],
  "ламб'єке": ['lambayeque', "ламб'єке", 'lambayeque'],
  апуримак: ['apurimac', 'апуримак', 'apurimac'],
  іка: ['ica', 'іка', 'ica'],
  арекіпа: ['arequipa', 'арекіпа', 'arequipa'],
  мооке: ['moque', 'мооке', 'moque'],
  пуно: ['puno', 'пуно', 'puno'],
  такна: ['tacna', 'такна', 'tacna'],
  'мадре-де-дьйос': ['madre de dios', 'мадре-де-дьйос', 'madrededios'],
  укаялі: ['ucayali', 'укайалі', 'ucayali'],
  лорето: ['loreto', 'лорето', 'loreto'],
  арабіка: ['arabica', 'арабіка', 'арабіки'],
  робуста: ['robusta', 'робуста', 'робусти'],
  еспрессо: ['espresso', 'еспрессо', 'еспресо'],
  фільтр: ['filter', 'фільтр', 'фільтрова'],
  капучино: ['cappuccino', 'капучино'],
  латте: ['latte', 'латте'],
  американо: ['americano', 'американо'],

  'wet hulled': ['wet hulled', 'вет халд', 'мокра лущення', 'гілінг басах'],
  'вет халд': ['wet hulled', 'вет халд', 'мокра лущення', 'гілінг басах'],

  'ruiru 11': ['ruiru 11', 'руіру 11', 'ruiru11'],
  'руіру 11': ['ruiru 11', 'руіру 11', 'ruiru11'],
  batian: ['batian', 'батіан', 'батян'],
  батіан: ['batian', 'батіан', 'батян'],
  'sl-34': ['sl-34', 'sl34', 'сл-34', 'сл34'],
  'сл-34': ['sl-34', 'sl34', 'сл-34', 'сл34'],
  'gayo 1': ['gayo 1', 'gayo1', 'гайо 1', 'гайо1'],
  'гайо 1': ['gayo 1', 'gayo1', 'гайо 1', 'гайо1'],
  'gayo 2': ['gayo 2', 'gayo2', 'гайо 2', 'гайо2'],
  'гайо 2': ['gayo 2', 'gayo2', 'гайо 2', 'гайо2'],
  'mix arabica': ['mix arabica', 'mix arabicа', 'мікс арабіка', 'мікс арабіки'],
  'мікс арабіка': ['mix arabica', 'mix arabicа', 'мікс арабіка', 'мікс арабіки'],

  'блу-маунтін': ['blue mountain', 'блу-маунтін', 'bluemountain'],
  кібер: ['kibera', 'кібер', 'kibera'],
  нгугі: ['ngugi', 'нгугі', 'ngugi'],
  карунгу: ['karungu', 'карунгу', 'karungu'],
}

export type SearchableProduct = Partial<
  Pick<
    Product,
    | 'name'
    | 'description'
    | 'originCountry'
    | 'originRegion'
    | 'categoryInternalName'
    | 'categoryExternalName'
    | 'farm'
  >
> & {
  beanType?: { label?: string } | null
  processingMethod?: { label?: string } | null
  beanVariety?: { label?: string } | null
  roastType?: { label?: string } | null
  grindType?: { label?: string } | null
  packageProductType?: { label?: string } | null
  tags?: Array<{ name?: string } | null> | null
}

const normalize = (value: string) => value.toLowerCase().trim()

const collectSearchableText = (product: SearchableProduct): string => {
  const parts = [
    product.name,
    product.description,
    product.originCountry,
    product.originRegion,
    product.categoryInternalName,
    product.categoryExternalName,
    product.farm,
    product.beanType?.label,
    product.processingMethod?.label,
    product.beanVariety?.label,
    product.roastType?.label,
    product.grindType?.label,
    product.packageProductType?.label,
    ...(product.tags || []).map(tag => tag?.name),
  ]

  return parts
    .filter((part): part is string => Boolean(part))
    .join(' ')
    .toLowerCase()
}

/** Expand a typed token to synonyms when it is a prefix of a known term. */
export const expandSearchToken = (
  token: string,
  mapping: Record<string, string[]> = SEARCH_SYNONYMS,
): string[] => {
  const typed = normalize(token)
  if (!typed) return []

  const synonyms = new Set<string>()

  for (const [key, values] of Object.entries(mapping)) {
    const candidates = [key, ...values].map(normalize)
    const hitsPrefix = candidates.some(
      candidate => candidate.startsWith(typed) || typed.startsWith(candidate),
    )

    if (hitsPrefix) {
      synonyms.add(normalize(key))
      values.forEach(value => synonyms.add(normalize(value)))
    }
  }

  // Prefer known synonyms over the raw prefix so "дрі" matches drips, not "дрібні фермери".
  return synonyms.size > 0 ? Array.from(synonyms) : [typed]
}

export const productMatchesSearch = (
  product: SearchableProduct,
  query: string,
  mapping: Record<string, string[]> = SEARCH_SYNONYMS,
): boolean => {
  if (!product?.name) return false

  const tokens = normalize(query).split(/\s+/).filter(Boolean)
  if (!tokens.length) return false

  const haystack = collectSearchableText(product)

  return tokens.every(token => {
    const expanded = expandSearchToken(token, mapping)
    return expanded.some(term => haystack.includes(term))
  })
}

export const filterProductsBySearch = <T extends SearchableProduct>(
  products: T[],
  query: string,
  mapping: Record<string, string[]> = SEARCH_SYNONYMS,
): T[] => {
  return products.filter(product => productMatchesSearch(product, query, mapping))
}
